__webpack_require__.p = "/interactive-component/";